import '/assets/styles/main.css';

import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';

import header from './components/alpine/header';
import dialogAgeGateKeeper from './components/alpine/dialogAgeGateKeeper';
import textFeatureRotate from './components/alpine/textFeatureRotate';
import dropdown from './components/alpine/dropdown';

import { revealEmail } from './components/revealEmail';

window.lazyloadInstance = new LazyLoad();
window.Alpine = Alpine;

Alpine.data('header', header);
Alpine.data('dialogAgeGateKeeper', dialogAgeGateKeeper);
// Alpine.data('textFeatureRotate', textFeatureRotate);
Alpine.data('dropdown', dropdown);

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  revealEmail();
});
